import {
  CURRENT_CHAT_INPUT_MESSAGES,
  CurrentChatInputMessages,
} from "./current-chat-input.messages";

export type CurrentChatMessages = CurrentChatInputMessages;

export const CURRENT_CHAT_MESSAGES: CurrentChatMessages = {
  //CURRENT CHAT INPUT
  ...CURRENT_CHAT_INPUT_MESSAGES,
};
